import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../Store";
// import { fieldOnChange, onErrorHandle } from "../../Utils/commonService";;
import {
  getErrorModel,
  getHideFields,
  getOptionMappingData,
  onSumbitStatus,
} from "../../Store/FormConfig/form.selectors";
import { useSelector } from "react-redux";
import {
  checkRule,
  defaultValue,
  fieldOnChange,
  onErrorHandle,
  setDefaultValueInModel,
  rule
} from "../../utils/commonService";
import styled from "styled-components";
type InputSizeType = "large" | "small" | "default";
export const AppCheckbox = (props: any) => {
	const { field, model, errorModel, type, fieldConfig,iconTitle,sectionId,showError,setLoading } = props
	const dispatch = useAppDispatch()
	const submitStatus = useSelector(onSumbitStatus);
	const errorModelData = useSelector(getErrorModel)
	const hideFields = useSelector(getHideFields)
	const optionMappingData = useSelector(getOptionMappingData)
	const [textInput, setTextInput] = useState("")
	const changeFn = (event: any) => {
		
		setTextInput(event?.target?.checked)
		fieldOnChange(event?.target?.checked, model, field, fieldConfig,sectionId,errorModelData, dispatch,setLoading,rule);
	}
	const onBlur = (value: any) => {
		onErrorHandle(field, errorModel, model, dispatch,sectionId,hideFields)	
	}
	useEffect(() => {
		// if(field?.default_value !== "" && field?.read_only){
		// 	setDefaultValueInModel(field?.default_value, model, field, fieldConfig,sectionId,errorModelData, dispatch);
		// }
		if(model[field?.id] || model[field?.name]){
            fieldOnChange(model[field?.id] || model[field?.name], model, field, fieldConfig, sectionId, errorModelData, dispatch,setLoading,rule);
        }
		setTextInput("")
		onErrorHandle(field, errorModel, model, dispatch,sectionId,hideFields)

		// setTimeout(function() {
			
		// 	checkRule("", model, field, fieldConfig,sectionId,errorModelData, dispatch)
		//   }, 900);		
	}, [])

	
	return <FormGroupWrapper>
		<div className="form-group">
			<div className="input-group mb-3">
			
				<input
                    style={{margin: "0px 6px"}}
					defaultChecked= {model[field?.id]}
					value={model[field?.id] || model[field?.name]  ? model[field?.id] || model[field?.name] : defaultValue[field?.id] }
					type={type}
					placeholder={field?.placeholder}
					onChange={(value: any) => changeFn(value)}
					onBlur={(value: any) => onBlur(value)}
					disabled={field?.read_only ? true :false}
				/>
                	  <div >
						{field?.label}
				</div> 
			</div>
			{showError && submitStatus && errorModelData[props?.field.id] ? <ul className="parsley-errors-list filled" id="parsley-id-29">
					<li className="parsley-required">
                    {errorModelData[props?.field.id]}
					</li> 
				</ul>: null}
		</div>
	</FormGroupWrapper>
}

const FormGroupWrapper = styled.div`
  && {
    button {
      z-index: 0 !important;
      border: 1px solid #ced4da !important;
      outline: none !important;
      border-right: 0px solid transparent !important;
    }
    button:focus {
      outline: none !important;
      box-shadow: none !important;
    }
  }
`;
